import { Toolbar } from "@components-common/toolbar";
import { Page } from "../../layout";
import { FC, useEffect, useState } from "react";
import { application } from "../../../_runtime/bootstrap";
import { Loader } from "taltech-styleguide";
import { ActionButton } from "../../buttons/ActionButton";
import { useUserContext } from "../../../_runtime/iam/session.context";

const props = {
  title: "EduBIM Revit plugin",
};

/**
 * Component: RevitPluginPage
 * 
 * This component represents the main page for managing Revit plugin versions.
 * It fetches and displays all available plugin versions and provides options
 * for certain roles to manage the plugins.
 * 
 * @component
 * @returns {React.FC} The RevitPluginPage component.
 */
export const RevitPluginPage: React.FC<any> = () => {
  const [pluginVersions, setPluginVersions] = useState<any>(undefined);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    application
      .getHttpClient()
      .get("/mediasms/mediaitemresources?type=INSTALLER")
      .then((res: any) => {
        setPluginVersions(res.body!.items);
      });
  }, []);

  useEffect(() => {
    if (pluginVersions) {
      setLoading(false);
    }
  }, [pluginVersions]);

  return (
    <Page {...props}>
      {loading ? (
        <Loader overlay />
      ) : (
        <>
          <Toolbar
            left={[
              {
                id: "create_new",
                kind: "create_new",
                roles: ["STUDY_DIRECTOR"],
              },
            ]}
            right={["back"]}
          />
          <h4 className="mb-2">All Revit plugin versions:</h4>
          <PluginVersions
            pluginVersions={pluginVersions}
            setPluginVersions={setPluginVersions}
          />
        </>
      )}
    </Page>
  );
};

/**
 * Component: PluginVersions
 * 
 * This component is responsible for rendering the list of Revit plugin versions. It also
 * provides functionality for deleting a plugin version if the user has the required role.
 * 
 * @component
 * @param {object} props - The props for the component.
 * @param {Array} props.pluginVersions - An array of plugin version objects.
 * @param {function} props.setPluginVersions - A function to update the plugin versions state.
 * @returns {React.FC} The PluginVersions component.
 */
const PluginVersions: FC<any> = ({ pluginVersions, setPluginVersions }) => {
  const { role } = useUserContext();
  const onDelete = (id: string, index: number) => {
    application
      .getHttpClient()
      .delete(`/mediasms/mediaitemresources/${id}`)
      .then(() => {
        const newPluginVersions = pluginVersions.filter(
          (x: any) => x.id !== id
        );
        setPluginVersions(newPluginVersions);
      });
  };
  return (
    <div className="d-flex flex-column">
      {pluginVersions.map((item: any, index: number) => {
        return (
          <div
            key={index}
            className="d-flex align-items-center plugin-version py-2 gap-2"
          >
            <h6 className="mb-0 mt-1">
              <a href={item.url} download={item.url}>
                {item.name}
              </a>
            </h6>
            {role === "STUDY_DIRECTOR" && (
              <ActionButton
                kind="delete"
                visual="icon"
                className="ms-3"
                onAction={() => onDelete(item.id, index)}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
